import { render, staticRenderFns } from "./recordTable.vue?vue&type=template&id=25600082&scoped=true&"
import script from "./recordTable.vue?vue&type=script&lang=js&"
export * from "./recordTable.vue?vue&type=script&lang=js&"
import style0 from "./recordTable.vue?vue&type=style&index=0&id=25600082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25600082",
  null
  
)

export default component.exports